<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '900px', height: '800px'}"
  styleClass="p-fluid assegna-massivamente-determine-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <!-- Loading Overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="loading-content">
        <div class="spinner-container">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #4f97c4;"></i>
        </div>
        <p class="loading-text">Elaborazione in corso...</p>
      </div>
    </div>

    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-file-check header-icon"></i>
        <h2>Assegnazione Massiva Determine</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()"
        [disabled]="isLoading">
      </button>
    </div>

    <!-- Progress Steps -->
    <div class="steps-container">
      <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
        <div class="step-number">1</div>
        <div class="step-label">Dati Determina</div>
      </div>
      <div class="step-separator"></div>
      <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
        <div class="step-number">2</div>
        <div class="step-label">Selezione Interventi</div>
      </div>
    </div>

    <div class="dialog-content">
      <!-- Step 1: Dati Determina -->
      <div *ngIf="currentStep === 1" class="step-content">
        <div class="step-header">
          <h3><i class="pi pi-file-edit"></i> Inserisci i dati della determina</h3>
          <p>Inserisci il numero della determina e carica il file associato</p>
        </div>

        <div class="field">
          <label for="numeroDetermina">Numero Determina *</label>
          <input
            id="numeroDetermina"
            type="text"
            pInputText
            [(ngModel)]="numeroDetermina"
            placeholder="Inserisci il numero della determina"
            [disabled]="isLoading"
            required />
        </div>

       <!--  <div class="field">
          <label for="note">Note</label>
          <textarea
            id="note"
            pInputTextarea
            [(ngModel)]="note"
            [rows]="3"
            placeholder="Inserisci eventuali note"
            style="width: 100%"></textarea>
        </div> -->

        <div class="field">
          <label for="fileDetermina">Allega il file della determina *</label>
          <p-fileUpload
            id="fileDetermina"
            mode="advanced"
            name="fileDetermina"
            accept=".p7m,.pdf,.doc,.docx"
            [maxFileSize]="10000000"
            chooseLabel="Seleziona File"
            (onSelect)="onFileSelect($event)"
            [auto]="true"
            styleClass="p-button-outlined"
            [multiple]="false"
            [disabled]="isLoading">
          </p-fileUpload>
        </div>
      </div>

      <!-- Step 2: Selezione Interventi -->
      <div *ngIf="currentStep === 2" class="step-content">
        <div class="step-header">
          <h3><i class="pi pi-list-check"></i> Seleziona gli interventi</h3>
          <p>Scegli l'anno, la richiesta e gli interventi a cui assegnare la determina</p>
        </div>

        <!-- Selezione Anno e Richiesta -->
        <div class="field-row">
          <div class="field field-anno">
            <label for="anno">Anno *</label>
            <p-dropdown
              id="anno"
              [options]="anniDisponibili"
              [(ngModel)]="annoSelezionato"
              placeholder="Anno"
              (onChange)="onAnnoChange()"
              [disabled]="isLoading"
              styleClass="w-full">
            </p-dropdown>
          </div>

          <div class="field field-richiesta" *ngIf="annoSelezionato">
            <label for="richiesta">Ente Esecutore *</label>
            <p-dropdown
              id="richiesta"
              [options]="richiesteAnno"
              [(ngModel)]="richiestaSelezionata"
              placeholder="Seleziona la richiesta"
              optionLabel="enteEsecutore.label"
              (onChange)="onRichiestaChange()"
              [loading]="isLoading"
              [disabled]="isLoading"
              styleClass="w-full">
              <ng-template pTemplate="item" let-richiesta>
                <div class="richiesta-item">
                  <div class="richiesta-titolo">{{ richiesta.enteEsecutore?.label }}</div>
                  <div class="richiesta-dettagli">
                    <span class="richiesta-importo">{{ richiesta.importoRichiesto | currency:'EUR':'symbol':'1.2-2' }}</span>
                    <span class="richiesta-stato" [class]="'stato-' + richiesta.stato?.id">
                      {{ richiesta.stato?.descrizione }}
                    </span>
                  </div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <!-- Selezione Interventi -->
        <div class="field" *ngIf="richiestaSelezionata && interventiRichiesta.length > 0">
          <div class="interventi-header">
            <label>Interventi da selezionare *</label>
            <div class="interventi-actions">
              <button
                pButton
                pRipple
                label="Seleziona Tutti"
                icon="pi pi-check-square"
                class="p-button-outlined p-button-sm"
                (click)="selectAllInterventi()"
                [disabled]="isLoading">
              </button>
              <button
                pButton
                pRipple
                label="Deseleziona Tutti"
                icon="pi pi-square"
                class="p-button-outlined p-button-sm"
                (click)="deselectAllInterventi()"
                [disabled]="isLoading">
              </button>
            </div>
            <!--  -->
          </div>

          <div class="interventi-list">

            <div class="intervento-item" *ngFor="let intervento of interventiRichiesta">

              <p-checkbox
                [value]="intervento"
                [ngModel]="isInterventoSelected(intervento)"
                (ngModelChange)="onInterventoSelect(intervento, $event)"
                [binary]="true"
                [disabled]="isLoading">
              </p-checkbox>
              <div class="intervento-info">
                <div class="intervento-titolo">Intervento {{ intervento.scheda?.codice }} ({{ intervento.scheda?.vecchioCodiceUmvs }}) -  {{ intervento.stato?.descrizione }}</div>
                                  <div class="intervento-dettagli">
                    <span class="importo-richiesto">RICHIESTO: {{ intervento.importoRichiesto | currency:'EUR':'symbol':'1.2-2' }}</span>
                    <span class="importo-finanziato">FINANZIATO: {{ intervento.importoFinanziato | currency:'EUR':'symbol':'1.2-2' }}</span>
                    <span class="importo-rendicontato">RENDICONTATO: {{ intervento.importoRendicontato | currency:'EUR':'symbol':'1.2-2' }}</span>
                  </div>
              </div>
            </div>
          </div>


        </div>

        <div class="no-data" *ngIf="richiestaSelezionata && interventiRichiesta.length === 0 && !isLoading">
          <i class="pi pi-exclamation-triangle"></i>
          <p>Nessun intervento trovato per questa richiesta</p>
        </div>
      </div>
    </div>

    <!-- Footer con pulsanti di navigazione -->
    <div class="dialog-footer">
      <div class="footer-left">
        <button
          pButton
          pRipple
          label="Annulla"
          icon="pi pi-times"
          class="p-button-outlined p-button-secondary"
          (click)="hide()">
        </button>
      </div>
      <div class="footer-center">
        <div class="selection-summary" *ngIf="interventiSelezionati.length > 0">
          <i class="pi pi-info-circle"></i>
          <span>{{ interventiSelezionati.length }} intervento/i selezionato/i</span>
        </div>
      </div>

      <div class="footer-right">
        <button
          *ngIf="currentStep === 2"
          pButton
          pRipple
          label="Indietro"
          icon="pi pi-arrow-left"
          class="p-button-outlined"
          (click)="prevStep()"
          [disabled]="isLoading">
        </button>

        <button
          *ngIf="currentStep === 1"
          pButton
          pRipple
          label="Avanti"
          icon="pi pi-arrow-right"
          iconPos="right"
          class="p-button-success"
          (click)="nextStep()"
          [disabled]="!isStep1Valid() || isLoading">
        </button>

        <button
          *ngIf="currentStep === 2"
          pButton
          pRipple
          label="Assegna"
          icon="pi pi-check"
          class="p-button-success"
          (click)="salvaDetermine()"
          [disabled]="!isStep2Valid() || isLoading"
          [loading]="isLoading">
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
